import { createWebHistory, createRouter } from "vue-router";

// Lazy-load views for code splitting
const MyHome = () => import(/* webpackChunkName: "home" */ "@/views/MyHome.vue")
const MyFlipbook = () => import(/* webpackChunkName: "flipbook" */ "@/views/MyFlipbook.vue")
const MyFlipbookOld = () => import(/* webpackChunkName: "flipbook-old" */ "@/views/MyFlipbookOld.vue")

const title = process.env.VUE_APP_COMMERCE_API_URL.toLowerCase().includes('tuneeca') ? 'Tuneeca Catalogue' : 'Bukakatalog'

const routes = [
  {
    path: "/",
    name: "Home",
    component: MyHome,
    meta: {
      title: title,
    },
  },
  {
    path: "/:slug",
    name: "Flipbook",
    component: MyFlipbook,
    meta: {
      title: title,
    },
  },
  {
    path: "/Flipbook",
    name: "Flipbook Old",
    component: MyFlipbookOld,
    meta: {
      title: title,
    },
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to) => {
  document.title = to.meta.title
})

export default router;